module.exports = __webpack_public_path__ + "img/kr-product-card3-item2-step3.d098fc3.png";